module.exports = __webpack_public_path__ + "img/sy-pic3.2c53cbff.png";